<div class="w-full relative tutorial-wrapper">
    <img class="w-lightbox-img w-lightbox-image" 
        src="data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns=%22http://www.w3.org/2000/svg%22%20width=%22940%22%20height=%22529%22/%3E">
        
    <iframe class="absolute inset-0 w-full h-full" title="video-tutorial"
        [src]="videoURL | safe"
        webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>

    <!-- <mat -->
    <!-- <mat-progress-spinner
        class="loading-bar"
        mode="indeterminate"
        value="50"
        diameter="36">
    </mat-progress-spinner> -->
</div>
